import moment from 'moment'
import type {TotalShipmentsResponse} from './_types'

export type TimeRange = 'ytd' | 'mtd' | 'wtd'

export type OrganizationPeriod = TimeRange | 'custom'

export const TIME_RANGES: {id: TimeRange; label: string}[] = [
  {id: 'ytd', label: 'YTD'},
  {id: 'mtd', label: 'MTD'},
  {id: 'wtd', label: 'WTD'},
]

export const getRangeForPreset = (range: TimeRange) => {
  const end = moment().endOf('day')

  switch (range) {
    case 'mtd':
      return {start: moment().startOf('month'), end}
    case 'wtd':
      return {start: moment().startOf('week'), end}
    case 'ytd':
    default:
      return {start: moment().startOf('year'), end}
  }
}

export type ShipmentTrendBreakout = 'overall' | 'carrier' | 'service'

export const SHIPMENT_TREND_BREAKOUTS: ShipmentTrendBreakout[] = ['overall', 'carrier', 'service']

export const TREND_VIEW_LABEL_KEYS: Record<ShipmentTrendBreakout, string> = {
  overall: 'OVERALL',
  carrier: 'CARRIER',
  service: 'SERVICE',
}

export const OVERALL_SERIES_COLOR = '#14B8A6'

export const TREND_SERIES_COLORS = ['#0B6D65', '#14B8A6', '#15569C', '#B1C360', '#FAB80A']

export const TREND_DAILY_AXIS_MAX_DAYS = 60

export const EMPTY_ANALYTICS_METRIC: TotalShipmentsResponse = {
  total: 0,
  delta: 0,
  period: '',
  carrier_breakout: [],
}
